$( document ).ready(function() {

	AOS.init();
    fitvid();
    revealed_menu_submenus();
    gallery_module();
    retreats_slider_module();
    chalet_slider_module();
    google_review_slider_module();
    chalet_testimonials_slider_module();
    vertical_season_image_module();

    // Fix slider accessibility after initialization
    setTimeout(function() {
        fixTnsAccessibility();
        initTnsAccessibilityObserver();
    }, 500);

    popup_gallery();
    on_hover();
    reveal_enquiry();
    goto_retreats_form();
    burger_trigger();
    offers_trigger();
    iframe_popup();
    chalet_description_reveal();
    reveal_expanding_retreats();

    

    
   $('.image-lightbox').magnificPopup({type:'image'});

   chalet_price_terms();

});

back_to_top();
fix_header_on_scroll();

function reveal_expanding_retreats()
{    
        $('.expanding-retreats__module .reveal-retreat').on( "click", function(e) {
           e.preventDefault();
           // console.log('.expanded ' + $(this).data('season'));
           $('.ctas .' + $(this).data('season')).hide();
           $('.ctas .season').removeClass('col-lg-6');
           $('.expanded .' + $(this).data('season') ).show();
            
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.expanded .' + $(this).data('season')).offset().top -100
            }, 0);

        });
}
    

function goto_retreats_form()
{    
        $('.goto-retreats-form').on( "click", function(e) {
           e.preventDefault();
            $([document.documentElement, document.body]).animate({
                scrollTop: $('.retreats-form__module').offset().top -100
            }, 0);
        });    
}


function reveal_enquiry()
{
    $(".reveal-enquiry").on( "click", function(e){
        e.preventDefault();
        $(".reveal-enquiry__module").show();
        $('html, body').animate({
            scrollTop: $(".reveal-enquiry__module").offset().top -250
        }, 1000);        
    });       
}







function chalet_price_terms()
{
    hide_show_extras_and_pricing('.nav-link.active');


    $(".availability-pricing__module .nav-link").on( "click", function(){
        hide_show_extras_and_pricing($(this));
    });    
}
function hide_show_extras_and_pricing($name) 
{
    $season_catered_type = $($name).attr( "data-price-terms" );
    $season_type = $($name).attr( "data-season" );
    
    $('.pricing-terms__module .catered, .pricing-terms__module .self-catered').hide();
    $('.pricing-terms__module .'+$season_catered_type).show();

    $('.extras-available__module .extra').hide();
    $('.extras-available__module .'+$season_type+'-'+$season_catered_type).show();    
}


function chalet_description_reveal() 
{
    $( ".chalet-description__module .show-description" ).on( "click", function(e) {
      e.preventDefault();
      $(this).fadeOut();
      $(".chalet-description__module .revealed-description").show("slow");
    });
}

function iframe_popup()
{
  $('.iframe-popup').magnificPopup({type:'iframe'});
}


function revealed_menu_submenus()
{
      $(".revealed-menu__module .sub-menu").each(function() {
            $parent_link = $(this).prev();
            $parent_link.addClass('sub-menu-parent').attr("href", "#");
            $($parent_link).on( "click", function() {
              $(this).next('.sub-menu').slideToggle();
            });            
      });
}

function burger_trigger() {
    $('.mega-menu-trigger .mega-menu-burger').on( "click", function() {
      // console.log('burger nom nom...');
      $(this).toggleClass('is-active');
      var isExpanded = $(this).hasClass('is-active');
      $(this).attr('aria-expanded', isExpanded);
      $('.main.mega-menu').slideToggle();
      $("html, body").scrollTop(0);
    });
}

function offers_trigger() {
    $('.offers-trigger').on( "click", function() {
      $('.expanded-offers').toggleClass('is-active');
      $('.expanded-offers').slideToggle();
// var $container = $("html,body");
// var $scrollTo = $('.offers');
// $container.animate({scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop()-200, scrollLeft: 0},300);       
    });
}

// Fix accessibility for Tiny Slider - prevent focus on hidden slides
function fixTnsAccessibility() {
    // Focusable elements selector
    var focusable = 'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"]), iframe';

    // Set tabindex=-1 on focusable elements in hidden slides
    $('.tns-item[aria-hidden="true"]').find(focusable).attr('tabindex', '-1');
    // Remove tabindex restriction on visible slides
    $('.tns-item:not([aria-hidden="true"])').find(focusable).each(function() {
        if ($(this).data('original-tabindex') !== undefined) {
            $(this).attr('tabindex', $(this).data('original-tabindex'));
        } else {
            $(this).removeAttr('tabindex');
        }
    });
}

// Run fix after any slider transition and on attribute changes
$(document).on('transitionend webkitTransitionEnd', '.tns-item', function() {
    fixTnsAccessibility();
});

// Observe aria-hidden attribute changes on slider items
function initTnsAccessibilityObserver() {
    if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function(mutations) {
            fixTnsAccessibility();
        });

        $('.tns-item').each(function() {
            observer.observe(this, { attributes: true, attributeFilter: ['aria-hidden'] });
        });
    }
}

function chalet_testimonials_slider_module() {
  if ($(".chalet-testimonials__module  .slider-testimonials").length > 0) {
    
    $controls_id = '#controls-testimonials';
    
    const tnsCarousel = document.querySelectorAll('.chalet-testimonials__module  .slider-testimonials');
    tnsCarousel.forEach(slider => {
          const tnsSlider = tns({
                  container: slider,
                  controlsContainer: $controls_id,                  
                  autoplayHoverPause: true,
                  speed: 500,
                  mouseDrag: false,
                  autoHeight: false,
                  center: true,
                  loop: true,
                  gutter: 0,
                  items: 1,
                  controls: true,
                  nav: false,
                  autoplayButtonOutput: false,
                  autoplay: false,
                  autoplayTimeout: 10000,
          });
    });

  }
}




function retreats_slider_module() {
  if ($(".retreats-slider__module .slider-retreats").length > 0) {
    
    $controls_id = '#controls-retreats';
    
    const tnsCarousel = document.querySelectorAll('.retreats-slider__module .slider-retreats');
    tnsCarousel.forEach(slider => {
          const tnsSlider = tns({
                  container: slider,
                  controlsContainer: $controls_id,                  
                  autoplayHoverPause: true,
                  speed: 500,
                  mouseDrag: false,
                  autoHeight: false,
                  center: true,
                  loop: true,
                  gutter: 0,
                  items: 1,
                  controls: true,
                  nav: false,
                  autoplayButtonOutput: false,
                  autoplay: false,
                  autoplayTimeout: 10000,
          });
    });

  }
}
function chalet_slider_module() {
  if ($(".chalet-slider__module .slider-chalet").length > 0) {

    let sliders = document.querySelectorAll('.chalet-slider__module .slider-chalet');
    let controls = document.querySelectorAll('.controls-chalet');
    let previous = document.querySelectorAll('.controls-chalet .prev');
    let next = document.querySelectorAll('.controls-chalet .next');

    for (let i = 0; i < sliders.length; i++) {
      tns({
        container: sliders[i],
        controlsContainer: controls[i],
        prevButton: previous[i],
        nextButton: next[i],
        autoplayHoverPause: true,
        speed: 500,
        mouseDrag: false,
        autoHeight: false,
        center: false,
        loop: true,
        gutter: 30,
        items: 1,
        controls: true,
        nav: false,
        autoplayButtonOutput: false,
        autoplay: false,
        autoplayTimeout: 10000,
        responsive: {
          1200: {
            items: 2,
            gutter: 30
          }
        }
      });
    }
  }
}
function google_review_slider_module() {
    if ($(".google-review-result__module .review-slider").length > 0) {
        let sliders = document.querySelectorAll('.google-review-result__module .review-slider');
        let controls = document.querySelectorAll('.controls-review');
        let previous = document.querySelectorAll('.controls-review .prev');
        let next = document.querySelectorAll('.controls-review .next');

        for (let i = 0; i < sliders.length; i++) {
            tns({
                container: sliders[i],
                controlsContainer: controls[i],
                prevButton: previous[i],
                nextButton: next[i],
                items: 1,
                slideBy: 'page',
                autoplayHoverPause: true,
                speed: 500,
                mouseDrag: true,
                autoHeight: false,
                center: true,
                loop: true,
                gutter: 0,
                controls: true,
                nav: false,
                autoplayButtonOutput: false,
                autoplay: false,
                autoplayTimeout: 10000,
                responsive: {
                    1200: {
                        disable: true
                    }
                }
            });
        }
    }
}




function vertical_season_image_module() {
  if ($(".vertical-season-image__module .slider").length > 0) {

    const tnsCarousel = document.querySelectorAll('.vertical-season-image__module .slider');
    tnsCarousel.forEach(slider => {
          const tnsSlider = tns({
                  container: slider,
                  autoplay: true,
                  mouseDrag: false,
                  autoHeight: false,
                  gutter: 0,
                  mode: "gallery",
                  items: 1,
                  controls: false,
                  nav: false,
                  autoplayButtonOutput: false,
          });
    });

  }
}



function gallery_module() {
  if ($(".gallery__module .gallery").length > 0) {

    const tnsCarousel = document.querySelectorAll('.gallery__module .gallery');
    tnsCarousel.forEach(slider => {
          const tnsSlider = tns({
                  container: slider,
                  autoplay: true,
                  mouseDrag: false,
                  autoHeight: false,
                  gutter: 0,
                  speed: 1000,
                  items: 1,
                  mode: "gallery",
                  controls: false,
                  nav: false,
                  autoplayButtonOutput: false,
          });
    });

  }
}

function back_to_top() {
    $('.back-to-top__module').on('click', function (e) {
        e.preventDefault();
        $('html,body').animate({
            scrollTop: 0
        }, 700);
    });
    $(window).scroll(function() {
        if ($(window).scrollTop() >= 100) {
            $("body").addClass("scrolling");
            $('.back-to-top__module').addClass('visible');
        } else {
            $("body").removeClass("scrolling");
            $('.back-to-top__module').removeClass('visible');
        }
    });
}


function fitvid() {
	$(".fit-vid").fitVids();
    $('iframe[src*="youtube"]').parent().fitVids();
}





function on_hover() {
    $('.hover-state').hover(
        function(){ $(this).addClass('hovering') },
        function(){ $(this).removeClass('hovering') }
    )
}




function fix_header_on_scroll() {


    $(window).on("load", function() {


            if ($(window).scrollTop() > 265) {

                var breakpoint = window.matchMedia("screen and (min-width:1200px)").matches;
                if ( breakpoint ) {
                    $(".top-bar__module").addClass("fixed-header animated slideInDown");
                    $(".top-bar-fixed-spacer").show();
                }

            } else {
                $(".top-bar__module").removeClass("fixed-header animated slideInDown");
                $(".top-bar-fixed-spacer").hide();
            }

        });
        $(window).scroll(function() {
            if ($(window).scrollTop() >= 265) {

                var breakpoint = window.matchMedia("screen and (min-width:1200px)").matches;
                if ( breakpoint ) {
                    $('.top-bar__module').addClass('fixed-header animated slideInDown');
                    $(".top-bar-fixed-spacer").show();
                }

            } else {
                $('.top-bar__module').removeClass('fixed-header animated slideInDown');
                $(".top-bar-fixed-spacer").hide();
            }
        });
    }


    function open_modal() {
        $('.open-modal').magnificPopup({
          type:'inline',
          midClick: true
        });
    }

    function popup_gallery() {
      if ($(".popup-gallery").length > 0) {
          $('.popup-gallery').each(function () {
              $(this).magnificPopup({
                  delegate: 'a',
                  type: 'image',
                  tLoading: 'Loading image #%curr%...',
                  mainClass: 'mfp-img-mobile',
                  gallery: {
                      enabled: true,
                      navigateByImgClick: true,
                      preload: [0, 1]
                  },
                    image: {
                      markup:   '<div class="mfp-figure">'+
                                    '<div class="mfp-close"></div>'+
                                    '<div class="mfp-img"></div>'+
                                    '<div class="mfp-bottom-bar">'+
                                     '<div class="mfp-title"></div>'+
                                     '</div>'+
                              '</div>',
                      cursor: 'mfp-zoom-out-cur',
                      verticalFit: true,
                        titleSrc: function(item) {
                            return item.el.attr('title');
                          },
                      tError: '<a href="%url%">The image</a> could not be loaded.'
                    }
              });
          });



  }
}



function fullscreen_slider() {

  $controls_id = '.controls-fullscreen-slider';
  $container_class = '.slider-fullscreen-slider';
  $slider_class = '.slider-fullscreen-slider';
  $slider_name = 'slider_fullscreen-slider';

     if ( $($slider_class).length > 0) {
        var $slider_name = tns({
        container: $container_class,
        controls: true,
        controlsContainer: $controls_id,
        items: 1,
        nav: false,
        slideBy: 1,
        center: true,
        mouseDrag: false,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayHoverPause: true,
        autoplayTimeout: 3000,
        loop: true,
        mode: 'gallery',
        speed: 3000,
        touch: true,
        preventActionWhenRunning: false,
        gutter: 0,
        swipeAngle: false
        });
      }


}

    function fbShare(url, title, descr, image, winWidth, winHeight) {
        var winTop = (screen.height / 2) - (winHeight / 2);
        var winLeft = (screen.width / 2) - (winWidth / 2);
        window.open('http://www.facebook.com/sharer.php?s=100&p[title]=' + title + '&p[summary]=' + descr + '&p[url]=' + url + '&p[images][0]=' + image, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
    }

    function googleShare(url, winWidth, winHeight) {
        window.open("https://plus.google.com/share?url=" + url + "", "", "width=" + winWidth + ", height=" + winHeight + "");
    }


// A stub for window.initGoogleMaps is emitted by full-map-module.php before the
// google-maps <script> tag so Google's callback never hits `undefined`. The stub
// records that Google called it and looks for __gmapsReal; we define the real
// impl under that name and, if the stub already fired, drain it immediately.
window.__gmapsReal = function() {
    if (typeof jQuery === 'undefined') {
        setTimeout(window.__gmapsReal, 100);
        return;
    }
    if (typeof window.initializeGoogleMaps === 'function') {
        window.initializeGoogleMaps();
    } else {
        setTimeout(window.__gmapsReal, 100);
    }
};
window.initGoogleMaps = window.__gmapsReal;
if (window.__gmapsCalled || (window.google && window.google.maps)) {
    window.__gmapsReal();
}

// Main application code
(function($) {
    'use strict';

    window.mapInstances = [];

    // Cached library imports (loaded once)
    var LIBS = null;
    var libsPromise = null;
    var initStarted = false;

    function loadLibs() {
        if (libsPromise) return libsPromise;
        libsPromise = (async function() {
            var results = await Promise.all([
                google.maps.importLibrary('maps'),
                google.maps.importLibrary('marker'),
                google.maps.importLibrary('core')
            ]);
            var maps = results[0], marker = results[1], core = results[2];
            LIBS = {
                Map: maps.Map,
                InfoWindow: maps.InfoWindow,
                Polygon: maps.Polygon,
                Polyline: maps.Polyline,
                AdvancedMarkerElement: marker.AdvancedMarkerElement,
                LatLngBounds: core.LatLngBounds
            };
        })();
        return libsPromise;
    }

    function makeMarkerImg(url, w, h) {
        var img = document.createElement('img');
        img.src = url;
        img.style.width = w + 'px';
        img.style.height = h + 'px';
        img.style.display = 'block';
        return img;
    }

    window.initializeGoogleMaps = async function() {
        if (initStarted) return;
        initStarted = true;

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
                initStarted = false;
                window.initializeGoogleMaps();
            });
            return;
        }

        try {
            await loadLibs();
        } catch (e) {
            console.error('Failed to load Google Maps libraries:', e);
            return;
        }

        map_size();

        if ($('.template-map-page').length) {
            var map = await initMap($('.map'));
            if (map) window.mapInstances.push(map);
        } else {
            var els = $('.map__module .map').toArray();
            for (var i = 0; i < els.length; i++) {
                var m = await initMap($(els[i]));
                if (m) window.mapInstances.push(m);
            }
        }
    };

    function map_size() {
        function setMapHeight() {
            $('.map').each(function() {
                var $map = $(this);
                var $module = $map.closest('.map__module');
                if ($module.length) {
                    var height = $module.height();
                    $map.css('height', height + 100);
                }
            });
        }

        setMapHeight();

        var resizeTimer;
        $(window).on('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(setMapHeight, 250);
        });
    }

    /**
     * initMap - renders a Google Map onto $el.
     * Async because the loaded libs are awaited at the call site.
     */
    async function initMap($el) {
        if (!$el || !$el.length) {
            console.error('Invalid map element');
            return null;
        }

        if ($el.width() === 0 || $el.height() === 0) {
            console.warn('Map element has no dimensions, setting defaults');
            $el.css({ width: '100%', height: '400px' });
        }

        if (!LIBS) {
            console.error('Google Maps libraries not loaded');
            return null;
        }

        var activeFilters = {
            chalets: true,
            ski_lift: false,
            bus_stop: false,
            bar: false,
            restaurant: false,
            other: false,
            bus_routes: false,
            ski_area: false
        };

        var busRoutes = [];
        var skiAreaPolygons = [];

        // Read inline .marker elements BEFORE map init (Google Maps clears innerHTML)
        var inlineMarkers = [];
        $el.find('.marker').each(function() {
            var $marker = $(this);
            var lat = $marker.data('lat');
            var lng = $marker.data('lng');
            var content = $marker.html();
            if (lat && lng) {
                inlineMarkers.push({lat: parseFloat(lat), lng: parseFloat(lng), content: content});
            }
        });

        var mapArgs = {
            zoom: $el.data('zoom') || 14,
            center: {lat: 46.0678, lng: 6.6413},
            mapId: '1392197713198bcdb4ba25a7',
            renderingType: 'RASTER'
        };

        var map;
        try {
            map = new LIBS.Map($el[0], mapArgs);
        } catch (error) {
            console.error('Failed to create map:', error);
            return null;
        }

        map.markers = [];

        if (typeof chaletData !== 'undefined' && chaletData && chaletData.length) {
            chaletData.forEach(function(chalet) {
                try { initChaletMarker(chalet, map); }
                catch (e) { console.error('Error loading chalet marker:', e); }
            });
        }

        if (typeof markerData !== 'undefined' && markerData && markerData.length) {
            markerData.forEach(function(m) {
                try { initCustomMarker(m, map); }
                catch (e) { console.error('Error loading custom marker:', e); }
            });
        }

        if (inlineMarkers.length) {
            inlineMarkers.forEach(function(md) {
                var marker = new LIBS.AdvancedMarkerElement({
                    position: {lat: md.lat, lng: md.lng},
                    map: map,
                    gmpClickable: !!md.content
                });

                if (md.content) {
                    var infoWindow = new LIBS.InfoWindow({ content: md.content });
                    marker.addListener('gmp-click', function() {
                        infoWindow.open({map: map, anchor: marker});
                    });
                    marker.infoWindow = infoWindow;
                }

                map.markers.push(marker);
            });
        }

        loadBusRoutes(map);

        if (typeof skiAreaData !== 'undefined' && skiAreaData && skiAreaData.length) {
            loadSkiArea(skiAreaData, map);
        }

        setTimeout(function() { centerMap(map); }, 500);

        // Initial visibility (AdvancedMarkerElement: detach by setting map = null)
        map.markers.forEach(function(marker) {
            if (marker.category && !activeFilters[marker.category]) {
                marker.map = null;
            }
        });

        busRoutes.forEach(function(route) { route.setVisible(activeFilters.bus_routes); });
        skiAreaPolygons.forEach(function(polygon) { polygon.setVisible(activeFilters.ski_area); });

        // Hide filter buttons for empty categories
        var categoryCounts = {
            chalets: 0, ski_lift: 0, bus_stop: 0, bar: 0, restaurant: 0, other: 0
        };
        map.markers.forEach(function(marker) {
            if (marker.category && categoryCounts.hasOwnProperty(marker.category)) {
                categoryCounts[marker.category]++;
            }
        });
        Object.keys(categoryCounts).forEach(function(category) {
            if (categoryCounts[category] === 0) {
                $('.filter-option[data-category="' + category + '"]').hide();
            }
        });
        $('.filter-option[data-category="bus_routes"]').show();
        $('.filter-option[data-category="ski_area"]').show();

        $(document).off('click', '.map-filter-controls .filter-option');
        $(document).on('click', '.map-filter-controls .filter-option', function() {
            var category = $(this).data('category');

            $(this).toggleClass('active');
            activeFilters[category] = !activeFilters[category];

            map.markers.forEach(function(marker) {
                if (marker.category && activeFilters[marker.category]) {
                    marker.map = map;
                } else if (marker.category && !activeFilters[marker.category]) {
                    marker.map = null;
                }
            });

            if (category === 'bus_routes') {
                busRoutes.forEach(function(route) { route.setVisible(activeFilters.bus_routes); });
            }
            if (category === 'ski_area') {
                skiAreaPolygons.forEach(function(polygon) { polygon.setVisible(activeFilters.ski_area); });
            }
        });

        return map;

        // ===== INNER FUNCTIONS =====

        function loadBusRoutes(map) {
            $.ajax({
                url: '/wp-content/themes/alikats/assets/js/bus-routes.json',
                dataType: 'json',
                success: function(data) {
                    if (data && data.Placemark) processBusRoutes(data, map);
                },
                error: function(xhr, status, error) {
                    console.error('Error loading bus routes data:', error);
                }
            });
        }

        function loadSkiArea(skiAreaData, map) {
            var skiAreaColors = {
                'morzine-les-gets': '#E9D1C4',
                'avoriaz': '#E9D1C4',
                'chatel': '#E9D1C4',
                'swiss': '#E9D1C4',
                'st-jean-d\'aulps': '#E9D1C4',
                'mt-chery-les-gets': '#E9D1C4'
            };

            skiAreaData.forEach(function(area) {
                if (!area.wkt) return;

                try {
                    var coordinates = parseWKTPolygon(area.wkt);
                    if (coordinates.length === 0) return;

                    var fillColor = skiAreaColors[area.name] || '#FF9800';

                    var polygon = new LIBS.Polygon({
                        paths: coordinates,
                        strokeColor: fillColor,
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: fillColor,
                        fillOpacity: 0.35,
                        map: map,
                        visible: activeFilters.ski_area
                    });

                    polygon.addListener('click', function(event) {
                        var infoWindow = new LIBS.InfoWindow({
                            content: '<div class="map-infowindow ski-area-infowindow"><h4>' + formatSkiAreaName(area.name) + '</h4></div>'
                        });
                        infoWindow.setPosition(event.latLng);
                        infoWindow.open(map);
                    });

                    skiAreaPolygons.push(polygon);
                } catch (error) {
                    console.error('Error creating ski area polygon:', error);
                }
            });
        }

        function formatSkiAreaName(name) {
            return name.split('-').map(function(word) {
                return word.charAt(0).toUpperCase() + word.slice(1);
            }).join(' ').replace('D\'aulps', 'd\'Aulps');
        }

        function parseWKTPolygon(wktString) {
            var coordinates = [];
            var match = wktString.match(/\(\((.*?)\)\)/);
            if (match && match[1]) {
                var coordPairs = match[1].split(',');
                coordPairs.forEach(function(pair) {
                    var parts = pair.trim().split(' ');
                    if (parts.length >= 2) {
                        var lng = parseFloat(parts[0]);
                        var lat = parseFloat(parts[1]);
                        if (!isNaN(lng) && !isNaN(lat)) {
                            coordinates.push({ lat: lat, lng: lng });
                        }
                    }
                });
            }
            return coordinates;
        }

        function processBusRoutes(data, map) {
            if (!data.Placemark || !data.Placemark.length) return;
            data.Placemark.forEach(function(placemark, index) {
                if (placemark.LineString && placemark.LineString.coordinates) {
                    var coordinates = parseBusRouteCoordinates(placemark.LineString.coordinates);
                    if (coordinates.length > 0) {
                        var routePath = new LIBS.Polyline({
                            path: coordinates,
                            geodesic: true,
                            strokeColor: '#b28369',
                            strokeOpacity: 0.8,
                            strokeWeight: 4,
                            map: map,
                            visible: activeFilters.bus_routes
                        });
                        routePath.routeName = placemark.name || 'Bus Route ' + (index + 1);
                        busRoutes.push(routePath);
                    }
                }
            });
        }

        function parseBusRouteCoordinates(coordinatesStr) {
            var cleanedStr = coordinatesStr.trim().replace(/\n/g, ' ').replace(/\s+/g, ' ');
            var coordPairs = cleanedStr.split(' ');
            var coordinates = [];
            coordPairs.forEach(function(pair) {
                var parts = pair.split(',');
                if (parts.length >= 2) {
                    var lng = parseFloat(parts[0]);
                    var lat = parseFloat(parts[1]);
                    if (!isNaN(lng) && !isNaN(lat)) {
                        coordinates.push({ lat: lat, lng: lng });
                    }
                }
            });
            return coordinates;
        }

        function initChaletMarker(chalet, map) {
            if (!chalet.lat || !chalet.lng) {
                console.error('Invalid chalet coordinates:', chalet);
                return null;
            }

            var content = makeMarkerImg('/wp-content/themes/alikats/assets/images/marker/chalet.svg', 50, 35);

            var marker = new LIBS.AdvancedMarkerElement({
                position: {
                    lat: parseFloat(chalet.lat),
                    lng: parseFloat(chalet.lng)
                },
                map: map,
                content: content,
                title: chalet.title || 'Chalet',
                gmpClickable: true
            });
            marker.category = 'chalets';

            var infoWindowContent = '<div class="map-infowindow chalet-infowindow">' +
                '<h4><a href="' + chalet.url + '">' + (chalet.title || 'Chalet') + '</h4></a>' +
                '<p>' + (chalet.description || '') + '</p>' +
                '</div>';

            var infoWindow = new LIBS.InfoWindow({ content: infoWindowContent });

            marker.addListener('gmp-click', function() {
                map.markers.forEach(function(m) {
                    if (m.infoWindow) m.infoWindow.close();
                });
                infoWindow.open({map: map, anchor: marker});
            });

            marker.infoWindow = infoWindow;
            map.markers.push(marker);
            return marker;
        }

        function initCustomMarker(markerData, map) {
            if (!markerData.lat || !markerData.lng) {
                console.error('Invalid marker coordinates:', markerData);
                return null;
            }

            var iconUrls = {
                ski_lift:   '/wp-content/themes/alikats/assets/images/marker/ski-lift.svg',
                bus_stop:   '/wp-content/themes/alikats/assets/images/marker/bus.svg',
                bar:        '/wp-content/themes/alikats/assets/images/marker/bar.svg',
                restaurant: '/wp-content/themes/alikats/assets/images/marker/restaurant.svg',
                other:      '/wp-content/themes/alikats/assets/images/marker/other.svg'
            };
            var url = iconUrls[markerData.type] || iconUrls.other;
            var content = makeMarkerImg(url, 40, 40);

            var marker = new LIBS.AdvancedMarkerElement({
                position: {
                    lat: parseFloat(markerData.lat),
                    lng: parseFloat(markerData.lng)
                },
                map: map,
                content: content,
                title: markerData.title || 'Location',
                gmpClickable: true
            });
            marker.category = markerData.type || 'other';

            var infoWindowContent = '<div class="map-infowindow marker-infowindow">' +
                                   '<h4>' + (markerData.title || 'Location') + '</h4>';
            if (markerData.url) {
                infoWindowContent += '<a href="' + markerData.url + '" class="info-link">Learn More</a>';
            }
            infoWindowContent += '</div>';

            var infoWindow = new LIBS.InfoWindow({ content: infoWindowContent });

            marker.addListener('gmp-click', function() {
                map.markers.forEach(function(m) {
                    if (m.infoWindow) m.infoWindow.close();
                });
                infoWindow.open({map: map, anchor: marker});
            });

            marker.infoWindow = infoWindow;
            map.markers.push(marker);
            return marker;
        }

        function centerMap(map) {
            if (!map.markers || map.markers.length === 0) return;

            var bounds = new LIBS.LatLngBounds();
            var centerMarkers = map.markers.filter(function(marker) {
                return !marker.category || marker.category === 'chalets';
            });

            if (centerMarkers.length === 0) return;

            centerMarkers.forEach(function(marker) {
                if (marker.position) bounds.extend(marker.position);
            });

            if (centerMarkers.length == 1) {
                map.setCenter(bounds.getCenter());
                map.setZoom(16);
            } else {
                map.fitBounds(bounds);
            }
        }
    }

})(jQuery);